import {
  type GeoSpacePolygonCoordinates,
  type GeoSpacePolygonItem,
} from "../types";

/** 従来の外周だけの形式と、穴・複数区画を持つ形式をLeafletのMultiPolygonへ揃える。 */
export const toMultiPolygonPositions = (
  coordinates: GeoSpacePolygonCoordinates
): GeoSpacePolygonItem[][][] => {
  if (coordinates.length === 0) return [];
  if (!Array.isArray(coordinates[0]))
    return [[coordinates as GeoSpacePolygonItem[]]];
  if (!Array.isArray(coordinates[0][0]))
    return [coordinates as GeoSpacePolygonItem[][]];
  return coordinates as GeoSpacePolygonItem[][][];
};
